import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

// Compatibility Layer
import { CompatibilityLayerModule } from './core/compatibility/index';

// Forms
import { MdbFormsModule } from './components/forms/forms.module';

// Core Components (Priority 1)
import { MdbAccordionModule } from './components/accordion/accordion.module';
import { MdbModalModule } from './components/modal/modal.module';
import { MdbDropdownModule } from './components/dropdown/dropdown.module';
import { MdbDatepickerModule } from './components/datepicker/datepicker.module';
import { MdbSelectModule } from './components/select/select.module';
import { MdbAutocompleteModule } from './components/autocomplete/autocomplete.module';
import { MdbTableModule } from './components/table/table.module';

// UI Components (Priority 2)
import { MdbCarouselModule } from './components/carousel/carousel.module';
import { MdbTabsModule } from './components/tabs/tabs.module';
import { MdbTooltipModule } from './components/tooltip/tooltip.module';
import { MdbPopoverModule } from './components/popover/popover.module';
import { MdbCollapseModule } from './components/collapse/collapse.module';
import { MdbChipsModule } from './components/chips/chips.module';
import { MdbCheckboxModule } from './components/checkbox/checkbox.module';
import { MdbRadioModule } from './components/radio/radio.module';

// Advanced Components (Priority 3)
import { MdbLightboxModule } from './components/lightbox/lightbox.module';
import { MdbLoadingModule } from './components/loading/loading.module';
import { MdbRatingModule } from './components/rating/rating.module';
import { MdbSidenavModule } from './components/sidenav/sidenav.module';
import { MdbStepperModule } from './components/stepper/stepper.module';
import { MdbScrollspyModule } from './components/scrollspy/scrollspy.module';
import { MdbRangeModule } from './components/range/range.module';
import { MdbTimepickerModule } from './components/timepicker/timepicker.module';

// Utilities (Priority 4)
import { MdbRippleModule } from './components/ripple/ripple.module';
import { MdbValidationModule } from './components/validation/validation.module';
import { MdbLazyLoadingModule } from './components/lazy-loading/lazy-loading.module';
import { MdbInfiniteScrollModule } from './components/infinite-scroll/infinite-scroll.module';
import { MdbChartModule } from './components/charts/charts.module';

// Basic UI Elements
import { MdbButtonModule } from './components/button/button.module';
import { MdbIconModule } from './components/icon/icon.module';
import { MdbToolbarModule } from './components/toolbar/toolbar.module';

const ADAPTED_MODULES = [
   // Forms
  MdbFormsModule,

  // Core Components
  MdbAccordionModule,
  MdbModalModule,
  MdbDropdownModule,
  MdbDatepickerModule,
  MdbSelectModule,
  MdbAutocompleteModule,
  MdbTableModule,

  // UI Components
  MdbCarouselModule,
  MdbTabsModule,
  MdbTooltipModule,
  MdbPopoverModule,
  MdbCollapseModule,
  MdbChipsModule,
  MdbCheckboxModule,
  MdbRadioModule,

  // Advanced Components
  MdbLightboxModule,
  MdbLoadingModule,
  MdbRatingModule,
  MdbSidenavModule,
  MdbStepperModule,
  MdbScrollspyModule,
  MdbRangeModule,
  MdbTimepickerModule,

  // Utilities
  MdbRippleModule,
  MdbValidationModule,
  MdbLazyLoadingModule,
  MdbInfiniteScrollModule,
  MdbChartModule,

  // Basic UI Elements
  MdbButtonModule,
  MdbIconModule,
  MdbToolbarModule,
];

const MODULES = [
  CommonModule,
  CompatibilityLayerModule,
  // Forms
  MdbFormsModule,

  // Core Components
  MdbAccordionModule,
  MdbModalModule,
  MdbDropdownModule,
  MdbDatepickerModule,
  MdbSelectModule,
  MdbAutocompleteModule,
  MdbTableModule,

  // UI Components
  MdbCarouselModule,
  MdbTabsModule,
  MdbTooltipModule,
  MdbPopoverModule,
  MdbCollapseModule,
  MdbChipsModule,
  MdbCheckboxModule,
  MdbRadioModule,

  // Advanced Components
  MdbLightboxModule,
  MdbLoadingModule,
  MdbRatingModule,
  MdbSidenavModule,
  MdbStepperModule,
  MdbScrollspyModule,
  MdbRangeModule,
  MdbTimepickerModule,

  // Utilities
  MdbRippleModule,
  MdbValidationModule,
  MdbLazyLoadingModule,
  MdbInfiniteScrollModule,
  MdbChartModule,

  // Basic UI Elements
  MdbButtonModule,
  MdbIconModule,
  MdbToolbarModule,
];

/**
 * MDB5 Adapted Module
 *
 * Main module for MDB5 Angular UI Kit adapted for Angular 15.
 * Includes all compatible components from MDB5 v8.0.0.
 *
 * Usage:
 * ```typescript
 * import { Mdb5AdaptedModule } from 'mdb5-adapted';
 *
 * @NgModule({
 *   imports: [Mdb5AdaptedModule]
 * })
 * export class AppModule { }
 * ```
 *
 * Or import individual modules:
 * ```typescript
 * import { MdbModalModule, MdbFormsModule } from 'mdb5-adapted';
 * ```
 */
@NgModule({
  imports: [
    CommonModule,
    CompatibilityLayerModule,
    ...ADAPTED_MODULES,
  ],
  exports: [
    ...ADAPTED_MODULES,
  ],
})
export class Mdb5AdaptedModule {
  static forRoot() {
    return {
      ngModule: Mdb5AdaptedModule,
      providers: [],
    };
  }
}
